module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/search/lines/green-0240d6e2b99d8546a8bd2b7e8c4409ff.webp";